export const FileNames = {
  InviteProvider: "Outerpond-Invite.xlsx",
  UploadSeekers: "Outerpond-Upload.xlsx",
  UploadAPI: "Outerpond-API-Documentation.pdf",
  DatabaseBackup: "Outerpond-Database-Backup.zip"
};